var map = {
	"./AddSquareBold.svg": [
		7107,
		7107
	],
	"./AddSquareRegular.svg": [
		87635,
		7635
	],
	"./AlertBold.svg": [
		40463,
		463
	],
	"./AlertRegular.svg": [
		66548,
		6548
	],
	"./AnnounceBold.svg": [
		63360,
		3360
	],
	"./AnnounceRegular.svg": [
		51804,
		1804
	],
	"./Apartment2Bold.svg": [
		50258,
		258
	],
	"./Apartment2Regular.svg": [
		25370,
		5370
	],
	"./ApartmentBold.svg": [
		39111,
		9111
	],
	"./ApartmentRegular.svg": [
		29485,
		9485
	],
	"./ArrowDownBold.svg": [
		73296,
		3296
	],
	"./ArrowDownCircleBold.svg": [
		93322,
		3322
	],
	"./ArrowDownCircleRegular.svg": [
		6868,
		6868
	],
	"./ArrowDownLeftBold.svg": [
		7403,
		7403
	],
	"./ArrowDownLeftRegular.svg": [
		53530,
		3530
	],
	"./ArrowDownRegular.svg": [
		93852,
		3852
	],
	"./ArrowDownRightBold.svg": [
		87097,
		7097
	],
	"./ArrowDownRightRegular.svg": [
		8084,
		8084
	],
	"./ArrowLeftBold.svg": [
		1002,
		1002
	],
	"./ArrowLeftCircleBold.svg": [
		9140,
		9140
	],
	"./ArrowLeftCircleRegular.svg": [
		86866,
		6866
	],
	"./ArrowLeftDownCircleBold.svg": [
		92353,
		2353
	],
	"./ArrowLeftDownCircleRegular.svg": [
		95158,
		5158
	],
	"./ArrowLeftRegular.svg": [
		40729,
		729
	],
	"./ArrowLeftUpCircleBold.svg": [
		78177,
		8177
	],
	"./ArrowLeftUpCircleRegular.svg": [
		27185,
		7185
	],
	"./ArrowRightBold.svg": [
		87977,
		7977
	],
	"./ArrowRightCircleBold.svg": [
		16627,
		6627
	],
	"./ArrowRightCircleRegular.svg": [
		50794,
		794
	],
	"./ArrowRightDownCircleBold.svg": [
		70585,
		585
	],
	"./ArrowRightDownCircleRegular.svg": [
		1873,
		1873
	],
	"./ArrowRightRegular.svg": [
		49970,
		9970
	],
	"./ArrowRightUpCircleBold.svg": [
		21974,
		1974
	],
	"./ArrowRightUpCircleRegular.svg": [
		20060,
		60
	],
	"./ArrowTrendingDownBold.svg": [
		10536,
		536
	],
	"./ArrowTrendingDownRegular.svg": [
		19260,
		9260
	],
	"./ArrowTrendingUpBold.svg": [
		64599,
		4599
	],
	"./ArrowTrendingUpRegular.svg": [
		94481,
		7450
	],
	"./ArrowUpBold.svg": [
		30688,
		688
	],
	"./ArrowUpCircleBold.svg": [
		62122,
		2122
	],
	"./ArrowUpCircleRegular.svg": [
		94639,
		4639
	],
	"./ArrowUpLeftBold.svg": [
		3617,
		3617
	],
	"./ArrowUpLeftRegular.svg": [
		17574,
		7574
	],
	"./ArrowUpRegular.svg": [
		53797,
		3797
	],
	"./ArrowUpRightBold.svg": [
		64926,
		4926
	],
	"./ArrowUpRightRegular.svg": [
		24401,
		4401
	],
	"./AtRegular.svg": [
		63942,
		5056
	],
	"./BadgeBold.svg": [
		918,
		918
	],
	"./BadgeRegular.svg": [
		50499,
		499
	],
	"./BagBold.svg": [
		15947,
		5947
	],
	"./BagCheckBold.svg": [
		73483,
		3483
	],
	"./BagCheckRegular.svg": [
		74536,
		4536
	],
	"./BagRegular.svg": [
		62618,
		2618
	],
	"./BankBold.svg": [
		80917,
		917
	],
	"./BankRegular.svg": [
		17464,
		7464
	],
	"./BikeBold.svg": [
		39321,
		9321
	],
	"./BikeRegular.svg": [
		19239,
		9239
	],
	"./BillList1.svg": [
		98033,
		8033
	],
	"./Bolt2Bold.svg": [
		90632,
		632
	],
	"./Bolt2Regular.svg": [
		17093,
		7093
	],
	"./Bookmark1Bold.svg": [
		78458,
		8458
	],
	"./Bookmark1Regular.svg": [
		95846,
		5846
	],
	"./Bookmark2Bold.svg": [
		41069,
		1069
	],
	"./Bookmark2Regular.svg": [
		5688,
		5688
	],
	"./BuildingBold.svg": [
		94730,
		4730
	],
	"./BuildingRegular.svg": [
		49969,
		9969
	],
	"./BulbBold.svg": [
		99122,
		9122
	],
	"./BulbRegular.svg": [
		48952,
		8952
	],
	"./BurgerMenuBold.svg": [
		38864,
		8864
	],
	"./BurgerMenuRegular.svg": [
		51629,
		1629
	],
	"./CalculatorBold.svg": [
		64816,
		4816
	],
	"./CalculatorRegular.svg": [
		51358,
		1358
	],
	"./CalenderBold.svg": [
		8980,
		8980
	],
	"./CalenderRegular.svg": [
		95037,
		5037
	],
	"./CameraBold.svg": [
		63539,
		3539
	],
	"./CameraRegular.svg": [
		72642,
		2642
	],
	"./CancelCallBold.svg": [
		43936,
		3936
	],
	"./CancelCallRegular.svg": [
		17959,
		7959
	],
	"./CarAddBold.svg": [
		76478,
		6478
	],
	"./CarAddRegular.svg": [
		40423,
		423
	],
	"./CarBold.svg": [
		24182,
		4182
	],
	"./CarFilledBold.svg": [
		25326,
		5326
	],
	"./CarFilledRegular.svg": [
		42025,
		2025
	],
	"./CarMinusBold.svg": [
		24933,
		4933
	],
	"./CarMinusRegular.svg": [
		63424,
		3424
	],
	"./CarRegular.svg": [
		77246,
		7246
	],
	"./CardBold.svg": [
		10371,
		371
	],
	"./CardRegular.svg": [
		19880,
		9880
	],
	"./CartBold.svg": [
		49793,
		9793
	],
	"./CartRegular.svg": [
		85531,
		5531
	],
	"./CashBold.svg": [
		29262,
		9262
	],
	"./CashRegular.svg": [
		77343,
		7343
	],
	"./CertificateBold.svg": [
		10681,
		681
	],
	"./CertificateRegular.svg": [
		44648,
		4648
	],
	"./ChatBubbleBold.svg": [
		92785,
		2785
	],
	"./ChatBubbleDotsBold.svg": [
		62024,
		2024
	],
	"./ChatBubbleDotsRegular.svg": [
		3524,
		3524
	],
	"./ChatBubbleGroupBold.svg": [
		50942,
		942
	],
	"./ChatBubbleGroupRegular.svg": [
		48379,
		8379
	],
	"./ChatBubbleLikeBold.svg": [
		42605,
		2605
	],
	"./ChatBubbleLikeRegular.svg": [
		91463,
		1463
	],
	"./ChatBubbleReadBold.svg": [
		63673,
		3673
	],
	"./ChatBubbleReadRegular.svg": [
		96734,
		6734
	],
	"./ChatBubbleRegular.svg": [
		57214,
		7214
	],
	"./CheckCircleBold.svg": [
		11513,
		1513
	],
	"./CheckCircleRegular.svg": [
		98903,
		8903
	],
	"./CheckSquareBold.svg": [
		77592,
		7592
	],
	"./CheckSquareRegular.svg": [
		43375,
		3375
	],
	"./ChevronDownBold.svg": [
		9612,
		9612
	],
	"./ChevronDownRegular.svg": [
		42786,
		2786
	],
	"./ChevronLeftBold.svg": [
		46976,
		6976
	],
	"./ChevronLeftRegular.svg": [
		92236,
		2568
	],
	"./ChevronRightBold.svg": [
		16709,
		6709
	],
	"./ChevronRightRegular.svg": [
		3721,
		3721
	],
	"./ChevronUpBold.svg": [
		2656,
		2656
	],
	"./ChevronUpRegular.svg": [
		35768,
		5768
	],
	"./CityBold.svg": [
		87181,
		7181
	],
	"./CityRegular.svg": [
		76422,
		6422
	],
	"./ClockBold.svg": [
		46730,
		6730
	],
	"./ClockRegular.svg": [
		72256,
		2518
	],
	"./CloseSquareBold.svg": [
		92045,
		2045
	],
	"./CloseSquareRegular.svg": [
		15749,
		5749
	],
	"./CompassBold.svg": [
		39628,
		9628
	],
	"./CompassRegular.svg": [
		85405,
		5405
	],
	"./ConfettiBold.svg": [
		41940,
		1940
	],
	"./ContactsBold.svg": [
		41465,
		1465
	],
	"./ContactsRegular.svg": [
		27731,
		7731
	],
	"./CopyBold.svg": [
		99963,
		9963
	],
	"./CopyRegular.svg": [
		62988,
		501
	],
	"./CrossBold.svg": [
		51053,
		1053
	],
	"./CrossCircleBold.svg": [
		72990,
		2990
	],
	"./CrossCircleRegular.svg": [
		62994,
		2994
	],
	"./CrossRegular.svg": [
		3434,
		3434
	],
	"./CrownBold.svg": [
		36678,
		6678
	],
	"./CrownRegular.svg": [
		40072,
		72
	],
	"./CupStarRegular.svg": [
		2427,
		2427
	],
	"./DecoratedArrow.svg": [
		97608,
		7608
	],
	"./DirectionBold.svg": [
		47507,
		7507
	],
	"./DirectionRegular.svg": [
		73502,
		3502
	],
	"./DiscountBold.svg": [
		82237,
		2237
	],
	"./DocumentBold.svg": [
		37618,
		7618
	],
	"./DocumentNew.svg": [
		79604,
		9604
	],
	"./Dot.svg": [
		42947,
		2947
	],
	"./DoubleTickBold.svg": [
		39496,
		9496
	],
	"./DoubleTickRegular.svg": [
		19121,
		9121
	],
	"./DownloadBold.svg": [
		66137,
		6137
	],
	"./DownloadRegular.svg": [
		12825,
		2825
	],
	"./DropBold.svg": [
		48272,
		8272
	],
	"./Edit2Bold.svg": [
		11229,
		1229
	],
	"./Edit2Regular.svg": [
		69003,
		9003
	],
	"./EditBold.svg": [
		14617,
		4617
	],
	"./EditRegular.svg": [
		389,
		389
	],
	"./EssentialsBold.svg": [
		10417,
		417
	],
	"./EssentialsRegular.svg": [
		78902,
		8902
	],
	"./ExclaimationCircleBold.svg": [
		79894,
		9894
	],
	"./ExclaimationCircleRegular.svg": [
		38010,
		8010
	],
	"./EyeBold.svg": [
		53055,
		3055
	],
	"./EyeClosedBold.svg": [
		680,
		680
	],
	"./EyeClosedRegular.svg": [
		36498,
		6498
	],
	"./EyeRegular.svg": [
		58914,
		8914
	],
	"./FileAddBold.svg": [
		27350,
		7350
	],
	"./FileAddRegular.svg": [
		2256,
		2256
	],
	"./FileBold.svg": [
		38604,
		8604
	],
	"./FileCheckBold.svg": [
		39872,
		9872
	],
	"./FileCheckRegular.svg": [
		94245,
		4245
	],
	"./FileLockedBold.svg": [
		10647,
		647
	],
	"./FileLockedRegular.svg": [
		22186,
		2186
	],
	"./FilePdfBold.svg": [
		52115,
		2115
	],
	"./FilePdfRegular.svg": [
		11003,
		1003
	],
	"./FileRegular.svg": [
		20298,
		298
	],
	"./FileRemoveBold.svg": [
		97908,
		7908
	],
	"./FileRemoveRegular.svg": [
		25186,
		5186
	],
	"./FileWarningBold.svg": [
		23853,
		3853
	],
	"./FileWarningRegular.svg": [
		37817,
		7817
	],
	"./FilterBold.svg": [
		46129,
		6129
	],
	"./FilterRegular.svg": [
		81867,
		1867
	],
	"./Flag2Bold.svg": [
		58430,
		8430
	],
	"./Flag2Regular.svg": [
		44604,
		4604
	],
	"./FlagBold.svg": [
		9804,
		9804
	],
	"./FlagRegular.svg": [
		89270,
		9270
	],
	"./FlashBold.svg": [
		59698,
		9698
	],
	"./FlashRegular.svg": [
		47039,
		7039
	],
	"./FolderBold.svg": [
		95519,
		5519
	],
	"./FolderRegular.svg": [
		77687,
		7687
	],
	"./FoodBold.svg": [
		83667,
		3667
	],
	"./FoodRegular.svg": [
		27949,
		7949
	],
	"./FuelDrop.svg": [
		86740,
		6740
	],
	"./FuelMeterBold.svg": [
		44696,
		4696
	],
	"./FuelMeterRegular.svg": [
		60942,
		4945
	],
	"./FuelStationBold.svg": [
		29249,
		9249
	],
	"./FuelStationRegular.svg": [
		83553,
		3553
	],
	"./GPS.svg": [
		22903,
		2903
	],
	"./GarageBold.svg": [
		36731,
		6731
	],
	"./GarageRegular.svg": [
		543,
		543
	],
	"./GateBold.svg": [
		47830,
		7830
	],
	"./GateRegular.svg": [
		26570,
		6570
	],
	"./Gavel.svg": [
		18014,
		8014
	],
	"./GiftBold.svg": [
		15071,
		5071
	],
	"./GiftRegular.svg": [
		39213,
		9213
	],
	"./GiftTopBold.svg": [
		94531,
		4531
	],
	"./GiftTopRegular.svg": [
		60315,
		315
	],
	"./GlobeBold.svg": [
		36501,
		6501
	],
	"./GlobeRegular.svg": [
		31300,
		1300
	],
	"./HeadphoneRegular.svg": [
		33450,
		3450
	],
	"./HeartBold.svg": [
		85454,
		5454
	],
	"./HeartRegular.svg": [
		52874,
		2874
	],
	"./HelpAndSupportBold.svg": [
		38745,
		8745
	],
	"./HelpAndSupportRegular.svg": [
		41744,
		1744
	],
	"./HistoryBold.svg": [
		89769,
		9769
	],
	"./HistoryRegular.svg": [
		41462,
		1462
	],
	"./HomeBold.svg": [
		22276,
		2276
	],
	"./HomeRegular.svg": [
		52149,
		2149
	],
	"./ImageBold.svg": [
		51505,
		1505
	],
	"./ImageRegular.svg": [
		41189,
		1189
	],
	"./IncomingCallBold.svg": [
		49266,
		9266
	],
	"./IncomingCallRegular.svg": [
		32603,
		2603
	],
	"./IndiaLetters.svg": [
		311,
		311
	],
	"./Info2CircleBold.svg": [
		67250,
		7250
	],
	"./Info2CircleRegular.svg": [
		42862,
		2862
	],
	"./InfoCircleBold.svg": [
		14875,
		4481
	],
	"./InfoCircleRegular.svg": [
		6751,
		6751
	],
	"./KebabMenuBold.svg": [
		26593,
		6593
	],
	"./KebabMenuRegular.svg": [
		72714,
		2714
	],
	"./KeyBold.svg": [
		49670,
		9670
	],
	"./KeyRegular.svg": [
		89956,
		9956
	],
	"./LikeBold.svg": [
		12997,
		2997
	],
	"./Link1Bold.svg": [
		53496,
		3496
	],
	"./Link1Regular.svg": [
		99610,
		9610
	],
	"./ListRegular.svg": [
		28855,
		8855
	],
	"./LocationBold.svg": [
		23516,
		3516
	],
	"./LocationRegular.svg": [
		56351,
		6351
	],
	"./LockBold.svg": [
		85420,
		5420
	],
	"./LockOpenBold.svg": [
		85275,
		5275
	],
	"./LockOpenRegular.svg": [
		74913,
		4913
	],
	"./LockRegular.svg": [
		45086,
		5086
	],
	"./LogoutRegular.svg": [
		97535,
		7535
	],
	"./LogoutRightBold.svg": [
		62421,
		2421
	],
	"./LogoutRightRegular.svg": [
		98755,
		8755
	],
	"./LongArrowDownBold.svg": [
		53065,
		3065
	],
	"./LongArrowDownRegular.svg": [
		9675,
		9675
	],
	"./LongArrowLeftBold.svg": [
		19809,
		9809
	],
	"./LongArrowLeftRegular.svg": [
		48337,
		8337
	],
	"./LongArrowRightBold.svg": [
		25941,
		5941
	],
	"./LongArrowRightRegular.svg": [
		6006,
		6006
	],
	"./LongArrowUpBold.svg": [
		97547,
		7547
	],
	"./LongArrowUpRegular.svg": [
		53953,
		3953
	],
	"./MailBold.svg": [
		36010,
		6010
	],
	"./MailOpenBold.svg": [
		88661,
		8661
	],
	"./MailOpenRegular.svg": [
		22914,
		2914
	],
	"./MailRegular.svg": [
		99718,
		9718
	],
	"./MeatballMenuBold.svg": [
		69889,
		9889
	],
	"./MeatballMenuCircleBold.svg": [
		94549,
		4549
	],
	"./MeatballMenuCircleRegular.svg": [
		16403,
		6403
	],
	"./MeatballMenuRegular.svg": [
		83770,
		3770
	],
	"./MedalStarBold.svg": [
		20464,
		464
	],
	"./MedalStarRegular.svg": [
		29349,
		9349
	],
	"./MegaPhone.svg": [
		68149,
		8149
	],
	"./MessageBold.svg": [
		16633,
		6633
	],
	"./MessageDotsBold.svg": [
		28905,
		8905
	],
	"./MessageDotsRegular.svg": [
		6437,
		6437
	],
	"./MessageGroupBold.svg": [
		80206,
		206
	],
	"./MessageGroupRegular.svg": [
		73307,
		3307
	],
	"./MessageLikeBold.svg": [
		99355,
		9355
	],
	"./MessageLikeRegular.svg": [
		33843,
		3843
	],
	"./MessageReadBold.svg": [
		54687,
		4687
	],
	"./MessageReadRegular.svg": [
		29387,
		9387
	],
	"./MessageRegular.svg": [
		29119,
		9119
	],
	"./MicrophoneBold.svg": [
		32880,
		2880
	],
	"./MicrophoneRegular.svg": [
		6094,
		6094
	],
	"./MinuBold.svg": [
		63178,
		3178
	],
	"./MinuRegular.svg": [
		63816,
		3816
	],
	"./MinusCircleBold.svg": [
		69510,
		9510
	],
	"./MinusCircleRegular.svg": [
		84761,
		4761
	],
	"./MinusSquareBold.svg": [
		59484,
		9484
	],
	"./MinusSquareRegular.svg": [
		83730,
		3730
	],
	"./NavigateBold.svg": [
		35679,
		5679
	],
	"./NavigateRegular.svg": [
		91835,
		1835
	],
	"./NotebookBold.svg": [
		22359,
		2359
	],
	"./NotebookRegular.svg": [
		70763,
		763
	],
	"./NotificationBold.svg": [
		18735,
		8735
	],
	"./NotificationRegular.svg": [
		24008,
		4008
	],
	"./NotificationSilentBold.svg": [
		70251,
		251
	],
	"./NotificationSilentRegular.svg": [
		67187,
		2884
	],
	"./NotificationTickBold.svg": [
		15225,
		5225
	],
	"./NotificationTickRegular.svg": [
		45107,
		5107
	],
	"./NounLimit.svg": [
		25894,
		5894
	],
	"./Offer2Bold.svg": [
		20400,
		400
	],
	"./Offer2Regular.svg": [
		25174,
		5174
	],
	"./OfferBold.svg": [
		70892,
		892
	],
	"./OfferRegular.svg": [
		29142,
		9142
	],
	"./PaperclipBold.svg": [
		63087,
		3087
	],
	"./PaperclipRegular.svg": [
		64292,
		4292
	],
	"./Park+VerifiedBold.svg": [
		31691,
		1691
	],
	"./Park+VerifiedRegular.svg": [
		6211,
		6211
	],
	"./ParkVerifiedBold.svg": [
		80699,
		699
	],
	"./ParkVerifiedRegular.svg": [
		23762,
		3762
	],
	"./PauseBold.svg": [
		54878,
		4878
	],
	"./PauseRegular.svg": [
		6514,
		6514
	],
	"./PercentageBold.svg": [
		74250,
		4250
	],
	"./PercentageRegular.svg": [
		73901,
		3901
	],
	"./PhoneBold.svg": [
		75463,
		5463
	],
	"./PhoneCallingBold.svg": [
		21958,
		1958
	],
	"./PhoneCallingRegular.svg": [
		94722,
		4722
	],
	"./PhoneRegular.svg": [
		63691,
		3691
	],
	"./PlayBold.svg": [
		78035,
		8035
	],
	"./PlayRegular.svg": [
		54169,
		4169
	],
	"./PlusBold.svg": [
		25784,
		5784
	],
	"./PlusCircleBold.svg": [
		80026,
		26
	],
	"./PlusCircleRegular.svg": [
		92057,
		2057
	],
	"./PlusRegular.svg": [
		44456,
		4456
	],
	"./QrCodeBold.svg": [
		16151,
		6151
	],
	"./QrCodeRegular.svg": [
		18519,
		8519
	],
	"./QuestionCircleBold.svg": [
		21326,
		1326
	],
	"./QuestionCircleRegular.svg": [
		12784,
		2784
	],
	"./RefreshBold.svg": [
		96324,
		6324
	],
	"./RefreshRegular.svg": [
		80519,
		519
	],
	"./RestartBold.svg": [
		2210,
		2210
	],
	"./RestartRegular.svg": [
		79072,
		9072
	],
	"./RestrictBold.svg": [
		79668,
		9668
	],
	"./RestrictRegular.svg": [
		60742,
		742
	],
	"./RevokeBold.svg": [
		66375,
		6375
	],
	"./RevokeRegular.svg": [
		47368,
		7368
	],
	"./RocketBold.svg": [
		21930,
		1930
	],
	"./RocketRegular.svg": [
		36283,
		6283
	],
	"./RoundDownArrowCircleBold.svg": [
		97515,
		3405
	],
	"./RoundDownArrowCircleRegular.svg": [
		16494,
		6494
	],
	"./RoundLeftArrowCircleBold.svg": [
		99756,
		9756
	],
	"./RoundLeftArrowCircleRegular.svg": [
		29103,
		9240
	],
	"./RoundRightArrowCircleBold.svg": [
		30178,
		178
	],
	"./RoundRightArrowCircleRegular.svg": [
		92493,
		2493
	],
	"./RoundUpArrowCircleBold.svg": [
		42248,
		2248
	],
	"./RoundUpArrowCircleRegular.svg": [
		71673,
		1673
	],
	"./RoutingBold.svg": [
		72605,
		5756
	],
	"./RupeeBold.svg": [
		86687,
		6687
	],
	"./RupeeRegular.svg": [
		16394,
		6394
	],
	"./SearchBold.svg": [
		61090,
		1090
	],
	"./SearchCircleBold.svg": [
		73041,
		3041
	],
	"./SearchCircleRegular.svg": [
		11774,
		1774
	],
	"./SearchRegular.svg": [
		45014,
		5014
	],
	"./SecurityScanner.svg": [
		87246,
		1810
	],
	"./SendBold.svg": [
		73507,
		3507
	],
	"./SendRegular.svg": [
		29762,
		9762
	],
	"./SettingsBold.svg": [
		83549,
		3549
	],
	"./SettingsRegular.svg": [
		88190,
		7559
	],
	"./Share1Bold.svg": [
		17232,
		7232
	],
	"./Share1Regular.svg": [
		85374,
		5374
	],
	"./ShareBold.svg": [
		63253,
		3253
	],
	"./ShareMultipleBold.svg": [
		72490,
		2490
	],
	"./ShareMultipleRegular.svg": [
		6941,
		6941
	],
	"./ShareRegular.svg": [
		44443,
		4443
	],
	"./ShieldBold.svg": [
		71181,
		1181
	],
	"./ShieldCheckBold.svg": [
		58350,
		8350
	],
	"./ShieldCheckRegular.svg": [
		73514,
		3514
	],
	"./ShieldCrossBold.svg": [
		16916,
		6916
	],
	"./ShieldCrossRegular.svg": [
		41094,
		1094
	],
	"./ShieldRegular.svg": [
		71417,
		1417
	],
	"./ShieldUserBold.svg": [
		55616,
		5616
	],
	"./ShieldUserRegular.svg": [
		8094,
		8094
	],
	"./ShieldWarningBold.svg": [
		51033,
		1033
	],
	"./ShieldWarningRegular.svg": [
		60220,
		220
	],
	"./Shop1Bold.svg": [
		23946,
		3946
	],
	"./Shop1Regular.svg": [
		8068,
		8068
	],
	"./Shop2Bold.svg": [
		21144,
		1144
	],
	"./Shop2Regular.svg": [
		6491,
		6491
	],
	"./SortHorizontalBold.svg": [
		78294,
		8294
	],
	"./SortHorizontalRegular.svg": [
		31729,
		1729
	],
	"./SortVerticleBold.svg": [
		80914,
		914
	],
	"./SortVerticleRegular.svg": [
		56545,
		6545
	],
	"./SpeedometerBold.svg": [
		79378,
		9378
	],
	"./SpeedometerRegular.svg": [
		63613,
		3613
	],
	"./StackBold.svg": [
		19258,
		9258
	],
	"./StackRegular.svg": [
		23518,
		3518
	],
	"./StarBold.svg": [
		19103,
		9103
	],
	"./StarCircleBold.svg": [
		76874,
		6874
	],
	"./StarCircleRegular.svg": [
		6273,
		6273
	],
	"./StarRegular.svg": [
		52988,
		2988
	],
	"./StarsBold.svg": [
		97787,
		7787
	],
	"./StarsInCircle.svg": [
		35834,
		5834
	],
	"./StarsRegular.svg": [
		93004,
		3004
	],
	"./SteeringBold.svg": [
		5157,
		5157
	],
	"./SteeringRegular.svg": [
		71392,
		1392
	],
	"./ThumbsUpBold.svg": [
		25100,
		5100
	],
	"./ThumbsUpRegular.svg": [
		25778,
		5778
	],
	"./TickBold.svg": [
		68228,
		8228
	],
	"./TickCircleBold.svg": [
		17397,
		7397
	],
	"./TickCircleRegular.svg": [
		15622,
		5622
	],
	"./TickRegular.svg": [
		39634,
		9634
	],
	"./TicketBold.svg": [
		49491,
		9491
	],
	"./TicketRegular.svg": [
		6180,
		6180
	],
	"./ToolBold.svg": [
		45336,
		5336
	],
	"./ToolRegular.svg": [
		60075,
		75
	],
	"./TrashBold.svg": [
		15593,
		5593
	],
	"./TrashRegular.svg": [
		43449,
		3449
	],
	"./TrophyFirstBold.svg": [
		49239,
		8558
	],
	"./TrophyFirstRegular.svg": [
		41383,
		1383
	],
	"./TrophyStarBold.svg": [
		85607,
		5607
	],
	"./TrophyStarRegular.svg": [
		95595,
		5595
	],
	"./TruckBold.svg": [
		74980,
		4980
	],
	"./TruckRegular.svg": [
		48101,
		8101
	],
	"./UnlikeBold.svg": [
		26701,
		6701
	],
	"./UnlikeRegular.svg": [
		53193,
		3193
	],
	"./UpiBold.svg": [
		87186,
		7186
	],
	"./UpiRegular.svg": [
		33403,
		3403
	],
	"./UploadBold.svg": [
		73372,
		3372
	],
	"./UploadRegular.svg": [
		31543,
		1543
	],
	"./UserAddBold.svg": [
		34594,
		4594
	],
	"./UserAddRegular.svg": [
		23942,
		3942
	],
	"./UserBlock.svg": [
		25358,
		5358
	],
	"./UserBold.svg": [
		54057,
		4057
	],
	"./UserCheckBold.svg": [
		57602,
		7602
	],
	"./UserGroup1Bold.svg": [
		4379,
		4379
	],
	"./UserGroup1Regular.svg": [
		74910,
		4910
	],
	"./UserGroup2Bold.svg": [
		90886,
		886
	],
	"./UserGroup2Regular.svg": [
		75154,
		5154
	],
	"./UserIdBold.svg": [
		70949,
		949
	],
	"./UserIdRegular.svg": [
		11080,
		1080
	],
	"./UserProfileBold.svg": [
		41442,
		1442
	],
	"./UserProfileRegular.svg": [
		86991,
		6991
	],
	"./UserRegular.svg": [
		24082,
		4082
	],
	"./UserSyncBold.svg": [
		28134,
		8134
	],
	"./UserSyncRegular.svg": [
		15818,
		5818
	],
	"./UserVerifiedCircleBold.svg": [
		96137,
		4988
	],
	"./UserVerifiedCircleRegular.svg": [
		22236,
		2236
	],
	"./VerifiedCheckBold.svg": [
		58962,
		8962
	],
	"./VerifiedCheckRegular.svg": [
		15635,
		5635
	],
	"./VideoBold.svg": [
		60140,
		140
	],
	"./VideoRegular.svg": [
		16115,
		6115
	],
	"./VolumeBold.svg": [
		62600,
		2600
	],
	"./VolumeOffBold.svg": [
		15192,
		5192
	],
	"./VolumeOffRegular.svg": [
		92756,
		2756
	],
	"./VolumeRegular.svg": [
		62530,
		2530
	],
	"./Whatsapp.svg": [
		37916,
		7916
	],
	"./WhatsappIcon.svg": [
		1603,
		1603
	],
	"./WidgetAddBold.svg": [
		28121,
		8121
	],
	"./WidgetAddRegular.svg": [
		85355,
		5355
	],
	"./WidgetBold.svg": [
		35143,
		5143
	],
	"./WidgetRegular.svg": [
		79674,
		9674
	],
	"./XtraRewards.svg": [
		13897,
		3897
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 69676;
module.exports = webpackAsyncContext;